<div class="image-popup-overlay" (click)="onClose()">
  <!-- Popup nav -->
  <div class="popup-nav" (click)="stopPropagation($event)">
    <span *ngIf="panorama" class="grab_icon" [ngbTooltip]="'Grab and move left-right'"><i
        class="fa fa-hand-rock-o"></i></span>
    <div *ngIf="isMarkerActive" style="padding: 0 11px; display: flex;">
      <span class="marker" [ngClass]="!markersVisible && 'gray-marker'" [ngbTooltip]="'Turn ON/OFF markers'"
        (click)="markersVisible = !markersVisible"></span>
    </div>
    <span class="download_icon" style="padding: 3px 11px;" (click)="downloadImage()"><i
        class="fa fa-download"></i></span>
    <span class="download_icon" style="font-size: 1.4rem;" (click)="onClose()"><i class="fa fa-close"></i></span>
  </div>

  <ng-container *ngIf="!panorama">
    <div class="image-popup-container" (click)="stopPropagation($event)">

      <ng-container *ngIf="isVideoFile(currentImage); else imageFile">
        <video controls class="video-player">
          <source src="{{videoUrl}}" type="video/mp4" />
          Browser not supported
        </video>
      </ng-container>

      <ng-template #imageFile>
        <img class="image" [src]="currentImage.previewFile.path" alt="Popup Image" (load)="onImageLoad()" />
        <!-- <img #image [src]="getCurrentImageUrl()" alt="Viewer Image" class="image" (load)="onImageLoad()" /> -->

        <ng-container *ngIf="markersVisible">
          <div *ngFor="let marker of markers; let index = index" appMarker [x]="marker?.fileMarker?.x"
            [y]="marker?.fileMarker?.y" (click)="showMarkerInfo(index)"></div>
        </ng-container>
      </ng-template>

      <div class="spinner" *ngIf="!originalImageLoaded">
        <div class="la-line-spin-fade-rotating">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div *ngIf="currentImage.type !== 'vin' && images.length > 1" id="arrow-left" class="arrow" (click)="leftSlide()">
        <img src="/assets/img/left-arrow.png" alt="arrow left">
      </div>
      <div *ngIf="currentImage.type !== 'vin' && images.length > 1" id="arrow-right" class="arrow"
        (click)="rightSlide()">
        <img src="/assets/img/right-arrow.png" alt="arrow right">
      </div>
    </div>
  </ng-container>

  <!-- Panorama image -->
  <div *ngIf="panorama" (click)="stopPropagation($event)">
    <div id="preview" class="panorama-image" (mousedown)="onMouseEnter($event.target)" #myPanoViewer id="myPanoViewer"
      [style.background-image]="'url(' + currentImage.previewFile.path + ')'">
    </div>

    <div *ngIf="images.length > 1" id="arrow-left" class="arrow" (click)="leftSlide()">
      <img src="/assets/img/left-arrow.png" alt="arrow left">
    </div>
    <div *ngIf="images.length > 1" id="arrow-right" class="arrow" (click)="rightSlide()">
      <img src="/assets/img/right-arrow.png" alt="arrow right">
    </div>
  </div>

  <!-- Other images for crop -->
  <ng-container *ngIf="isCrop; else markersContent">
    <div id="thumbnail" style="max-width: 720px; width: 100%; padding: 0 15px" (click)="stopPropagation($event)">
      <div class="thumbnail-container image-container">
        <ng-container *ngIf="images.length > 0">
          <div *ngFor="let image of images; let index = index" class="thumbnail">
            <img *ngIf="image !== null" [src]="image.previewFile?.thumbnailPath"
              [ngClass]="currentIndex === index && 'selected'" alt="Thumbnail" (click)="openInSlider(index)">
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Markers -->
  <ng-template #markersContent>
    <div *ngIf="isMarkerActive" id="thumbnail" style="max-width: 720px; width: 100%; min-height: 104px; padding: 0 15px"
      (click)="stopPropagation($event)">
      <p style="color: #fff">Markers: ({{markers.length || 0}})</p>
      <div class="thumbnail-container image-container">
        <ng-container *ngIf="markers.length > 0">
          <div *ngFor="let marker of markers; let index = index" class="thumbnail" (click)="showMarkerInfo(index)">
            <img *ngIf="marker !== null" [src]="marker.image?.thumbnailPath" alt="Thumbnail">
            <img *ngIf="marker !== null" style="display: none;" [src]="marker?.image?.path" alt="Popup Image">
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>

</div>

<div *ngIf="isDownloading">
  <div *appSpinner="isDownloading; message: 'Downloading...'"></div>
</div>

<app-modal id="marker-info" style="position: relative; z-index: 9999;" [isMarker]="true" *ngIf="toggleMarkerInfo"
  (close)="toggleMarkerInfo = false">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>Marker</p>

    <div style="position: relative; min-width: 240px;">
      <img class="img-fluid" [src]="currentMarker?.image?.path" alt="Popup Image">
      <div *ngIf="markers.length > 1" id="arrow-left" class="arrow arrow-bg" (click)="navigateMarker(-1)">
        <img src="/assets/img/left-arrow.png" alt="arrow left">
      </div>
      <div *ngIf="markers.length > 1" id="arrow-right" class="arrow arrow-bg" (click)="navigateMarker(1)">
        <img src="/assets/img/right-arrow.png" alt="arrow right">
      </div>
    </div>

    <p class="marker-head-text">{{currentMarker.title}}</p>
    <hr>
    <p class="marker-head-text">{{currentMarker.type | uppercase}}</p>
    <hr>
    <p style="color: #313237; line-height: 21px;">{{currentMarker?.description}}</p>
  </div>
</app-modal>